import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/logo/logo_UIA_transparent.webp")